var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfCircleIcon',{staticClass:"sf-header__circle-icon a-search-icon",attrs:{"icon":"search","icon-size":"20px","icon-color":"black","role":"button","aria-label":_vm.$t('Open search panel')},on:{"click":_vm.toggleSearchpanel}})}
var staticRenderFns = []

export { render, staticRenderFns }